class SchoolAddress {
    city: string;
    state: string;
    country: string

    constructor(data: Partial<SchoolAddress>) {
        Object.assign(this, data);
    }
}

export default SchoolAddress;